import { useState } from 'react';
import type { SyncManatalJobsResult } from '@hrlabs/shared-types';
import { syncManatalJobs } from '../../lib/functions';
import { useToast } from '../../components/Toast';

export function JobManagement() {
  const { notify } = useToast();
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState<SyncManatalJobsResult | null>(null);

  const run = async () => {
    setRunning(true);
    setResult(null);
    try {
      const res = await syncManatalJobs();
      setResult(res.data);
      notify('success', `Synced: ${res.data.created} created, ${res.data.updated} updated.`);
    } catch (err) {
      notify('danger', `Sync failed: ${(err as Error).message}`);
    } finally {
      setRunning(false);
    }
  };

  return (
    <>
      <h3 className="fw-bold mb-3">Job Management</h3>
      <p className="text-muted">
        Pulls the current job list from Manatal&rsquo;s public career-page API and upserts it into
        Firestore.
      </p>
      <button className="btn btn-success" onClick={run} disabled={running}>
        {running ? 'Syncing…' : 'Sync jobs from Manatal'}
      </button>
      {result && (
        <div className="alert alert-primary mt-3">
          <strong>Done.</strong> {result.created} created, {result.updated} updated,{' '}
          {result.total} total. ({new Date(result.ranAt).toLocaleString()})
        </div>
      )}
    </>
  );
}
